export const PERMISSIONS = {
  // Employee Management
  EMPLOYEE_MANAGEMENT_VIEW: "EMPLOYEE_MANAGEMENT_VIEW",
  EMPLOYEE_MANAGEMENT_MANAGE: "EMPLOYEE_MANAGEMENT_MANAGE",

  // Employee Profile (My Profile)
  EMPLOYEE_PROFILE_VIEW: "EMPLOYEE_PROFILE_VIEW",
  EMPLOYEE_PROFILE_MANAGE: "EMPLOYEE_PROFILE_MANAGE",

  // Leave & Attendance - Apply Leave
  APPLY_LEAVE_VIEW: "APPLY_LEAVE_VIEW",
  APPLY_LEAVE_MANAGE: "APPLY_LEAVE_MANAGE",

  // Leave & Attendance - Apply AR (Attendance Regularization)
  APPLY_AR_VIEW: "APPLY_AR_VIEW",
  APPLY_AR_MANAGE: "APPLY_AR_MANAGE",

  // Leave & Attendance - Regularization Management
  REGULARIZATION_MANAGEMENT_VIEW: "REGULARIZATION_MANAGEMENT_VIEW",
  REGULARIZATION_MANAGEMENT_MANAGE: "REGULARIZATION_MANAGEMENT_MANAGE",

  // Leave & Attendance - Leave Approvals
  LEAVE_REQUESTS_VIEW: "LEAVE_REQUESTS_VIEW",
  LEAVE_REQUESTS_MANAGE: "LEAVE_REQUESTS_MANAGE",

  // Leave & Attendance - My Attendance
  MY_ATTENDANCE_VIEW: "MY_ATTENDANCE_VIEW",
  MY_ATTENDANCE_MANAGE: "MY_ATTENDANCE_MANAGE",

  // Timesheet - My Timesheet
  MY_TIMESHEETS_VIEW: "MY_TIMESHEETS_VIEW",
  MY_TIMESHEETS_MANAGE: "MY_TIMESHEETS_MANAGE",

  // Timesheet - Timesheet Management
  TIMESHEET_MANAGEMENT_VIEW: "TIMESHEET_MANAGEMENT_VIEW",
  TIMESHEET_MANAGEMENT_MANAGE: "TIMESHEET_MANAGEMENT_MANAGE",

  // Performance - My Performance
  MY_PERFORMANCE_VIEW: "MY_PERFORMANCE_VIEW",
  MY_PERFORMANCE_MANAGE: "MY_PERFORMANCE_MANAGE",

  // Performance - KPI Scoring
  KPI_SCORES_VIEW: "KPI_SCORES_VIEW",
  KPI_SCORES_MANAGE: "KPI_SCORES_MANAGE",

  // Reports - Attendance Report
  REPORTS_ATTENDANCE_VIEW: "REPORTS_ATTENDANCE_VIEW",
  REPORTS_ATTENDANCE_MANAGE: "REPORTS_ATTENDANCE_MANAGE",

  // Reports - Regularization Report
  REPORTS_REGULARIZATION_VIEW: "REPORTS_REGULARIZATION_VIEW",
  REPORTS_REGULARIZATION_MANAGE: "REPORTS_REGULARIZATION_MANAGE",

  // Reports - Leave Balance Report
  REPORTS_LEAVE_BALANCE_VIEW: "REPORTS_LEAVE_BALANCE_VIEW",
  REPORTS_LEAVE_BALANCE_MANAGE: "REPORTS_LEAVE_BALANCE_MANAGE",

  // Reports - Dynamic Reports
  REPORTS_DYNAMIC_VIEW: "REPORTS_DYNAMIC_VIEW",
  REPORTS_DYNAMIC_MANAGE: "REPORTS_DYNAMIC_MANAGE",

  // Surveys - My Surveys
  // MY_SURVEYS_VIEW: "MY_SURVEYS_VIEW",
  // MY_SURVEYS_MANAGE: "MY_SURVEYS_MANAGE",

  // Surveys - Survey Responses
  SURVEY_RESPONSE_VIEW: "SURVEY_RESPONSE_VIEW",
  SURVEY_RESPONSE_MANAGE: "SURVEY_RESPONSE_MANAGE",

  // Resource Allocation - Project Management
  PROJECT_MANAGEMENT_VIEW: "PROJECT_MANAGEMENT_VIEW",
  PROJECT_MANAGEMENT_MANAGE: "PROJECT_MANAGEMENT_MANAGE",

  // Resource Allocation - Project Analytics
  PROJECT_ANALYTICS_VIEW: "PROJECT_ANALYTICS_VIEW",
  PROJECT_ANALYTICS_MANAGE: "PROJECT_ANALYTICS_MANAGE",

  // Resource Allocation - Resource Management
  RESOURCE_MANAGEMENT_VIEW: "RESOURCE_MANAGEMENT_VIEW",
  RESOURCE_MANAGEMENT_MANAGE: "RESOURCE_MANAGEMENT_MANAGE",

  // Employee Self Service
  EMPLOYEE_SELF_SERVICE_VIEW: "EMPLOYEE_SELF_SERVICE_VIEW",
  EMPLOYEE_SELF_SERVICE_MANAGE: "EMPLOYEE_SELF_SERVICE_MANAGE",

  // Admin Config - Leave Balance
  LEAVE_BALANCES_VIEW: "LEAVE_BALANCES_VIEW",
  LEAVE_BALANCES_MANAGE: "LEAVE_BALANCES_MANAGE",

  // Admin Config - Access Right Management (backend: ACCESS_RIGHT_*)
  ACCESS_RIGHT_VIEW: "ACCESS_RIGHT_VIEW",
  ACCESS_RIGHT_MANAGE: "ACCESS_RIGHT_MANAGE",

  // Admin Config - Control Center (Feature Flags)
  FEATURE_FLAGS_VIEW: "FEATURE_FLAGS_VIEW",
  FEATURE_FLAGS_MANAGE: "FEATURE_FLAGS_MANAGE",

  // Admin Config - Holiday Management
  HOLIDAY_MANAGEMENT_VIEW: "HOLIDAY_MANAGEMENT_VIEW",
  HOLIDAY_MANAGEMENT_MANAGE: "HOLIDAY_MANAGEMENT_MANAGE",

  // Admin Config - Master Config
  MASTER_CONFIG_VIEW: "MASTER_CONFIG_VIEW",
  MASTER_CONFIG_MANAGE: "MASTER_CONFIG_MANAGE",

  // Admin Config - KPI Assignment
  KPI_ASSIGNMENTS_VIEW: "KPI_ASSIGNMENTS_VIEW",
  KPI_ASSIGNMENTS_MANAGE: "KPI_ASSIGNMENTS_MANAGE",

  // Admin Config - Employee Service
  EMPLOYEE_SERVICE_VIEW: "EMPLOYEE_SERVICE_VIEW",
  EMPLOYEE_SERVICE_MANAGE: "EMPLOYEE_SERVICE_MANAGE",

  // Game Booking
  GAME_BOOKING_VIEW: "GAME_BOOKING_VIEW",
  GAME_BOOKING_MANAGE: "GAME_BOOKING_MANAGE",

  // Referral
  REFERRAL: "REFERRAL",
  REFERRAL_VIEW: "REFERRAL_VIEW",
  REFERRAL_MANAGE: "REFERRAL_MANAGE",

  TEAM_LEAVE_APPROVALS_MANAGE: "LEAVE_REQUESTS_MANAGE",
  TEAM_AR_APPROVALS_MANAGE: "APPLY_AR_MANAGE",
  TEAM_TIMESHEET_APPROVALS_MANAGE: "TIMESHEET_MANAGEMENT_MANAGE",
  ADMIN_CREATE_LEAVE_VIEW: "APPLY_LEAVE_VIEW",
  ADMIN_CREATE_LEAVE_MANAGE: "APPLY_LEAVE_MANAGE",
  MY_LEAVE_REQUESTS_VIEW: "APPLY_LEAVE_VIEW",
  MY_LEAVE_REQUESTS_MANAGE: "APPLY_LEAVE_MANAGE",
  MY_ATTENDANCE_REGULARIZATION_VIEW: "APPLY_AR_VIEW",
  MY_ATTENDANCE_REGULARIZATION_MANAGE: "APPLY_AR_MANAGE",
  TIMESHEET_APPROVALS_VIEW: "TIMESHEET_MANAGEMENT_VIEW",
  TIMESHEET_APPROVALS_MANAGE: "TIMESHEET_MANAGEMENT_MANAGE",
  TIMESHEET_MY_VIEW: "MY_TIMESHEETS_VIEW",
  ADMIN_REGULARIZATION_MANAGEMENT_VIEW: "REGULARIZATION_MANAGEMENT_VIEW",
  ADMIN_REGULARIZATION_MANAGEMENT_MANAGE: "REGULARIZATION_MANAGEMENT_MANAGE",
  SURVEY_CAMPAIGNS_VIEW: "SURVEY_RESPONSE_VIEW",
  SURVEY_CAMPAIGNS_MANAGE: "SURVEY_RESPONSE_MANAGE",
  ADMIN_CONFIG_FEATURE_FLAGS_VIEW: "FEATURE_FLAGS_VIEW",
  ADMIN_CONFIG_FEATURE_FLAGS_MANAGE: "FEATURE_FLAGS_MANAGE",
  ADMIN_CONFIG_MASTER_CONFIG_VIEW: "MASTER_CONFIG_VIEW",
  ADMIN_CONFIG_MASTER_CONFIG_MANAGE: "MASTER_CONFIG_MANAGE",
  SURVEY_BUILDER_VIEW: "SURVEY_BUILDER_VIEW",
  SURVEY_BUILDER_MANAGE: "SURVEY_BUILDER_MANAGE",
  SURVEY_RESPONSES_VIEW: "SURVEY_RESPONSE_VIEW",
  SURVEY_RESPONSES_MANAGE: "SURVEY_RESPONSE_MANAGE",
  MY_SURVEYS_MANAGE_VIEW: "MY_SURVEYS_MANAGE_VEIW",
  MY_SURVEYS_MANAGE: "MY_SURVEYS_MANAGE",
  SURVEY_MANAGEMENT_VIEW: "SURVEY_MANAGEMENT_VIEW",
  SURVEY_MANAGEMENT_MANAGE: "SURVEY_MANAGEMENT_MANAGE",

  WORKFLOW_VIEW: "WORKFLOW_VIEW",
  WORKFLOW_MANAGE: "WORKFLOW_MANAGE",
  MANAGE_WORKFLOW_VIEW: "MANAGE_WORKFLOW_VIEW",
  MANAGE_WORKFLOW_MANAGE: "MANAGE_WORKFLOW_MANAGE",
  MANAGE_GROUPS_VIEW: "MANAGE_GROUPS_VIEW",
  MANAGE_GROUPS_MANAGE: "MANAGE_GROUPS_MANAGE",

  REFER_CANDIDATE_VIEW: "REFER_CANDIDATE_VIEW",
  REFER_CANDIDATE_MANAGE: "REFER_CANDIDATE_MANAGE",
  MY_REFERRALS_VIEW: "MY_REFERRALS_VIEW",
  MY_REFERRALS_MANAGE: "MY_REFERRALS_MANAGE",

  ORGANIZATION_ONBOARDING_VIEW: "ORGANIZATION_ONBOARDING_VIEW",
  ORGANIZATION_ONBOARDING_MANAGE: "ORGANIZATION_ONBOARDING_MANAGE",

  BILLING_LICENSE_VIEW: "BILLING_LICENSE_VIEW",
  BILLING_LICENSE_MANAGE: "BILLING_LICENSE_MANAGE",

  // Config Management - Week-off Config
  WEEK_OFF_CONFIG_VIEW: "WEEK_OFF_CONFIG_VIEW",
  WEEK_OFF_CONFIG_MANAGE: "WEEK_OFF_CONFIG_MANAGE",

  // Config Management - Organization Config
  ORGANIZATION_CONFIG_VIEW: "ORGANIZATION_CONFIG_VIEW",
  ORGANIZATION_CONFIG_MANAGE: "ORGANIZATION_CONFIG_MANAGE",

  // User Documents
  USER_DOCUMENTS: "USER_DOCUMENTS",
  USER_DOCUMENTS_VIEW: "USER_DOCUMENTS_VIEW",
  USER_DOCUMENTS_MANAGE: "USER_DOCUMENTS_MANAGE",

  // Help Center
  HELP_CENTER_VIEW: "HELP_CENTER_VIEW",
  HELP_CENTER_MANAGE: "HELP_CENTER_MANAGE",

  // Help Center Admin
  HELP_CENTER_ADMIN_VIEW: "HELP_CENTER_ADMIN_VIEW",
  HELP_CENTER_ADMIN_MANAGE: "HELP_CENTER_ADMIN_MANAGE",

  // Separation / exit (ESS + approvers)
  MY_EXIT_VIEW: "MY_EXIT_VIEW",
  MY_EXIT_MANAGE: "MY_EXIT_MANAGE",
  /** Line manager (and workflow actors): approve/reject, suggest LWD (API: OR with EXIT_APPROVALS_MANAGE). */
  EXIT_APPROVALS: "EXIT_APPROVALS",
  EXIT_APPROVALS_VIEW: "EXIT_APPROVALS_VIEW",
  EXIT_APPROVALS_MANAGE: "EXIT_APPROVALS_MANAGE",
  EXIT_SETTLEMENT_VIEW: "EXIT_SETTLEMENT_VIEW",
  EXIT_SETTLEMENT_MANAGE: "EXIT_SETTLEMENT_MANAGE",
  RESIGNATION: "RESIGNATION",
  RESIGNATION_MANAGE: "RESIGNATION_MANAGE",
  RESIGNATION_VIEW: "RESIGNATION_VIEW",
  /** Termination module (employer-initiated exit) */
  TERMINATION: "TERMINATION",
  /** Legacy / umbrella; some backends emit this instead of split submodule codes */
  TERMINATION_MANAGE: "TERMINATION_MANAGE",
  TERMINATION_VIEW: "TERMINATION_VIEW",
  TERMINATION_INITIATE_MANAGE: "TERMINATION_INITIATE_MANAGE",
  TERMINATION_APPROVALS_MANAGE: "TERMINATION_APPROVALS_MANAGE",

  // Email Templates
  EMAIL_TEMPLATES_VIEW: "EMAIL_TEMPLATES_VIEW",
  EMAIL_TEMPLATES_MANAGE: "EMAIL_TEMPLATES_MANAGE",

  // Email Config
  EMAIL_CONFIG_VIEW: "EMAIL_CONFIG_VIEW",
  EMAIL_CONFIG_MANAGE: "EMAIL_CONFIG_MANAGE",

  // Org Chart
  ORG_CHART_VIEW: "ORG_CHART_VIEW",
  ORG_CHART_MANAGE: "ORG_CHART_MANAGE",
  ORG_CHART_APPROVALS: "ORG_CHART_APPROVALS",
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const BILLING_LICENSE_ACCESS_PERMISSIONS: PermissionCode[] = [
  PERMISSIONS.BILLING_LICENSE_VIEW,
  PERMISSIONS.BILLING_LICENSE_MANAGE,
];
